/* eslint-disable no-unused-vars */
export const COUNTRIES = {
  GERMANY: "DE",
  SWITZERLAND: "CH",
};

export enum FILTER_OPTIONS {
  ALL = "all",
  FILTER = "filter",
  MY_REGISTERED = "registered",
}

export const FILTER_TYPES = {
  CITY: "city",
  CLUB: "club",
};
